import { policyholderTypes } from '@/entities/insurance/config/policyholder-type';

export default {
  computed: {
    policyholderTypes() {
      return policyholderTypes;
    },
  },
  methods: {
    getPolicyholderTypeKey(id) {
      return this.policyholderTypes?.find(t => t.id === Number(id))?.key ?? null;
    },
    getPolicyholderTypeId(key) {
      return this.policyholderTypes?.find(t => t.key === key)?.id ?? null;
    },
    getPolicyholderTypeName(id) {
      return this.policyholderTypes?.find(t => t.id === Number(id))?.value ?? null;
    },
    getPolicyholderTypeNameByKey(key) {
      return this.policyholderTypes?.find(t => t.key === key)?.value ?? null;
    },
  },
};
